import React, { Fragment } from 'react'
import * as Component from './components'

export default () => {
    return (
        <Fragment>
            <Component.EmployeeTypes />
            <Component.Employees />
        </Fragment>
    )
}